import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router-dom";
import { routes } from "../utils/Constants";
import Survey from "../pages/home/Survey";
import Login from "../pages/auth/Login";
import MainLayout from "../layouts/MainLayout";
import Dashboard from "../pages/dashboard/Dashboard";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../utils/firebase";
import SessionDetails from "../pages/sessionDetails/SessionDetails";
import QrCode from "../pages/qr/QrCode";
import Profile from "../pages/profile/Profile";
import NotFoundError from "../pages/error/NotFoundError";
import SignUp from "../pages/auth/SignUp";
const AppRoute = () => {
  const [loading, setLoading] = useState(true);
  const checkAuth = () => {
    try {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          const uid = user.uid;
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkAuth();
    return checkAuth;
  }, []);
  const router = createBrowserRouter([
    {
      path: routes.HOME,
      element: <MainLayout />,
      children: [
        {
          path: routes.HOME,
          element: <Dashboard />
        },
       
        {
          path: routes.SESSION_DETAILS,
          element: <SessionDetails />
        },
        {
          path: routes.QR_CODE,
          element: <QrCode />
        },
        {
          path: routes.PROFILE,
          element: <Profile />
        },
        {
          path: routes.NOT_FOUND,
          element: <NotFoundError />
        }
      ]
    },
    {
      path: routes.LOGIN,
      element: <Login />
    },
    {
      path: routes.SIGNUP,
      element: <SignUp />
    },
    {
      path: routes.SURVEY,
      element: <Survey />
    },
  ]);
  if (loading) return;

  return <RouterProvider router={router} />;
};

export default AppRoute;
